import React, { FC, useContext } from 'react'
import { ChatContext } from '~/service/chatConn'

type AiCompletionCancelProps = {}

const AiCompletionCancel: FC<AiCompletionCancelProps> = ({}) => {
  const { activeChat, aiCompletionApplied } = useContext(ChatContext)

  if (!activeChat.aiCompletion) {
    return null
  }

  return (
    <div
      className="chat-input-aiCompletionCancel"
      onClick={() => {
        aiCompletionApplied(activeChat.id)
      }}
    >
      <span className="far fa-circle-stop"></span>

      {intl.formatMessage({
        id: 'chat / input / ai completion / cancel',
      })}
    </div>
  )
}

export default AiCompletionCancel
